const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';

export default isProduction;
